import { render, staticRenderFns } from "./WalletCardPhotoSelect.vue?vue&type=template&id=0a109c4a&scoped=true&"
import script from "./WalletCardPhotoSelect.vue?vue&type=script&lang=js&"
export * from "./WalletCardPhotoSelect.vue?vue&type=script&lang=js&"
import style0 from "./WalletCardPhotoSelect.vue?vue&type=style&index=0&id=0a109c4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a109c4a",
  null
  
)

export default component.exports